/**
 * Size Variant Swatches - Displays images for "Size (in CM)" variant options
 * This script automatically finds size variant options and displays corresponding images
 */

(function() {
  'use strict';

  // Mapping of size values to image URLs
  const SIZE_IMAGE_MAP = {
    '20x20': 'https://cdn.shopify.com/s/files/1/0959/8641/7939/files/20x20.png',
    '30x20': 'https://cdn.shopify.com/s/files/1/0959/8641/7939/files/30x20.png',
    '30x30': 'https://cdn.shopify.com/s/files/1/0959/8641/7939/files/30x30.png',
    '40x30': 'https://cdn.shopify.com/s/files/1/0959/8641/7939/files/40x30.png',
    '40x40': 'https://cdn.shopify.com/s/files/1/0959/8641/7939/files/40x40.png',
    '50x50': 'https://cdn.shopify.com/s/files/1/0959/8641/7939/files/50x50.png',
    '60x20': 'https://cdn.shopify.com/s/files/1/0959/8641/7939/files/60x20.png',
    '60x40': 'https://cdn.shopify.com/s/files/1/0959/8641/7939/files/60x40.png',
    '60x60': 'https://cdn.shopify.com/s/files/1/0959/8641/7939/files/60x60.png',
    '70x50': 'https://cdn.shopify.com/s/files/1/0959/8641/7939/files/70x50.png',
    '80x40': 'https://cdn.shopify.com/s/files/1/0959/8641/7939/files/80x40.png',
    '80x80': 'https://cdn.shopify.com/s/files/1/0959/8641/7939/files/80x80.png',
    '90x30': 'https://cdn.shopify.com/s/files/1/0959/8641/7939/files/90x30.png',
    '90x60': 'https://cdn.shopify.com/s/files/1/0959/8641/7939/files/90x60.png',
    '100x70': 'https://cdn.shopify.com/s/files/1/0959/8641/7939/files/100x70.png',
    '100x100': 'https://cdn.shopify.com/s/files/1/0959/8641/7939/files/100x100.png',
    '120x40': 'https://cdn.shopify.com/s/files/1/0959/8641/7939/files/120x40.png',
    '120x80': 'https://cdn.shopify.com/s/files/1/0959/8641/7939/files/120x80.png',
    '150x50': 'https://cdn.shopify.com/s/files/1/0959/8641/7939/files/150x50.png',
    '150x100': 'https://cdn.shopify.com/s/files/1/0959/8641/7939/files/150x100.png',
    '200x90': 'https://cdn.shopify.com/s/files/1/0959/8641/7939/files/200x90.png',
    '200x100': 'https://cdn.shopify.com/s/files/1/0959/8641/7939/files/200x100.png'
  };

  /**
   * Safely escapes a value for usage inside an attribute selector.
   */
  function escapeAttributeValue(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }
    return value.replace(/"/g, '\\"');
  }

  /**
   * Toggles the selected class on labels based on the checked state.
   */
  function updateSelectionStateByName(name) {
    if (!name) return;
    const escapedName = escapeAttributeValue(name);
    const selector = `.xo-product-info-variant__item--size-image input[type="radio"][name="${escapedName}"]`;
    const radios = document.querySelectorAll(selector);

    radios.forEach((radio) => {
      const label = radio.closest('label.xo-field-color-style2');
      if (!label) return;
      label.classList.toggle('size-swatch--selected', radio.checked);
    });
  }

  /**
   * Ensures selection state stays in sync for a given radio input.
   */
  function bindSelectionStateListener(input) {
    if (!input || input.dataset.sizeSelectionBound === 'true') {
      return;
    }
    input.addEventListener('change', () => {
      updateSelectionStateByName(input.name);
    });
    input.dataset.sizeSelectionBound = 'true';
    updateSelectionStateByName(input.name);
  }

  /**
   * Normalizes a size value to match the map keys
   * Handles different formats: "20×20", "20x20", "20 x 20", etc.
   */
  function normalizeSizeValue(value) {
    if (!value) return '';
    
    return value
      .toString()
      .toLowerCase()
      .replace(/×/g, 'x')           // Replace multiplication sign with 'x'
      .replace(/[Xx]/g, 'x')       // Ensure all X's are lowercase
      .replace(/\s+/g, '')         // Remove all whitespace
      .trim();
  }

  /**
   * Gets the image URL for a given size value
   */
  function getSizeImageUrl(sizeValue) {
    const normalized = normalizeSizeValue(sizeValue);
    return SIZE_IMAGE_MAP[normalized] || null;
  }

  /**
   * Creates an image element for a size swatch
   */
  function createSizeImage(imageUrl, altText) {
    const img = document.createElement('img');
    img.src = imageUrl;
    img.alt = altText || '';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.style.width = '100%';
    img.style.height = '100%';
    img.style.objectFit = 'contain';
    img.style.display = 'block';
    return img;
  }

  /**
   * Processes a single variant option item
   */
  function processVariantItem(item) {
    // Skip if already processed
    if (item.dataset.sizeSwatchProcessed === 'true') {
      return;
    }

    // Find the radio input
    const input = item.querySelector('input[type="radio"]');
    if (!input) return;
    bindSelectionStateListener(input);

    // Get the size value from various possible attributes
    const sizeValue = input.getAttribute('xo-label') || 
                     input.getAttribute('value') || 
                     input.value ||
                     input.closest('label')?.textContent?.trim();

    if (!sizeValue) return;

    // Get the image URL
    const imageUrl = getSizeImageUrl(sizeValue);
    if (!imageUrl) return;

    // Check if image wrapper already exists
    let imageWrapper = item.querySelector('.size-swatch__image-wrapper');
    
    if (!imageWrapper) {
      // Create image wrapper
      imageWrapper = document.createElement('div');
      imageWrapper.className = 'size-swatch__image-wrapper';
      
      // Find the label or container to insert the image
      const label = item.querySelector('label') || item.querySelector('.xo-field-color-style2');
      if (label) {
        // Insert before the label or as first child
        const existingImage = label.querySelector('.xo-field-color-style2__image');
        if (existingImage) {
          existingImage.innerHTML = '';
          existingImage.appendChild(createSizeImage(imageUrl, sizeValue));
          imageWrapper = existingImage;
        } else {
          // Create new image container
          const imageContainer = document.createElement('div');
          imageContainer.className = 'xo-field-color-style2__image';
          imageContainer.appendChild(createSizeImage(imageUrl, sizeValue));
          
          // Insert into label
          if (label.firstChild) {
            label.insertBefore(imageContainer, label.firstChild);
          } else {
            label.appendChild(imageContainer);
          }
          imageWrapper = imageContainer;
        }
      } else {
        // Fallback: insert at the beginning of the item
        item.insertBefore(imageWrapper, item.firstChild);
        imageWrapper.appendChild(createSizeImage(imageUrl, sizeValue));
      }
    } else {
      // Update existing image
      const existingImg = imageWrapper.querySelector('img');
      if (existingImg) {
        existingImg.src = imageUrl;
        existingImg.alt = sizeValue;
      } else {
        imageWrapper.appendChild(createSizeImage(imageUrl, sizeValue));
      }
    }

    // Mark as processed
    item.dataset.sizeSwatchProcessed = 'true';
  }

  /**
   * Processes all size variant options on the page
   */
  function processSizeVariants() {
    // Find all variant containers that might contain size options
    const variantContainers = document.querySelectorAll(
      '.xo-product-info-variant__item--size-image, ' +
      '.xo-product-info-variant__inner, ' +
      'xo-product-variant'
    );

    variantContainers.forEach(container => {
      // Check if this is a "Size (in CM)" option
      const header = container.closest('.xo-product-info-variant')?.querySelector('.xo-product-info-variant__header');
      const isSizeOption = header && (
        header.textContent.includes('Size (in CM)') || 
        header.textContent.includes('Size')
      );

      if (!isSizeOption && !container.classList.contains('xo-product-info-variant__item--size-image')) {
        return;
      }

      // Find all variant items within this container
      const items = container.querySelectorAll(
        '.xo-product-info-variant__item--size-image, ' +
        'label.xo-field-color-style2, ' +
        '.xo-field-color-style2'
      );

      if (items.length === 0) {
        // Try processing the container itself if it's an item
        if (container.classList.contains('xo-product-info-variant__item--size-image')) {
          processVariantItem(container);
        }
      } else {
        items.forEach(processVariantItem);
      }
    });
  }

  /**
   * Accordion helpers for variant blocks
   */
  function setupVariantAccordion(container) {
    if (!container || container.dataset.variantAccordionBound === 'true') {
      return;
    }

    const header = container.querySelector('.xo-product-info-variant__header');
    const panel = container.querySelector('[data-variant-accordion-panel]');

    if (!header || !panel) {
      return;
    }

    container.dataset.variantAccordionBound = 'true';

    if (!panel.id) {
      panel.id = `variant-panel-${Math.random().toString(36).slice(2)}`;
    }

    header.setAttribute('aria-controls', panel.id);

    const startExpanded = header.getAttribute('aria-expanded') !== 'false';
    header.setAttribute('aria-expanded', startExpanded ? 'true' : 'false');
    panel.hidden = !startExpanded;
    container.classList.toggle('is-open', startExpanded);

    header.addEventListener('click', () => {
      const isExpanded = header.getAttribute('aria-expanded') === 'true';
      const nextState = !isExpanded;
      header.setAttribute('aria-expanded', nextState ? 'true' : 'false');
      panel.hidden = !nextState;
      container.classList.toggle('is-open', nextState);
    });
  }

  function initVariantAccordions(root = document) {
    let containers = [];
    if (root instanceof Element || root instanceof Document) {
      containers = root.querySelectorAll('[data-variant-accordion]');
    }
    containers.forEach(setupVariantAccordion);
  }

  /**
   * Initializes the size variant swatches
   */
  function init() {
    function runInitializers() {
      processSizeVariants();
      initVariantAccordions();
    }

    // Process on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runInitializers);
    } else {
      runInitializers();
    }

    // Re-process when variant options change (for dynamic updates)
    const observer = new MutationObserver(function(mutations) {
      let shouldReprocess = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              if (node.classList && (
                node.classList.contains('xo-product-info-variant') ||
                node.classList.contains('xo-product-info-variant__item--size-image') ||
                node.querySelector('.xo-product-info-variant')
              )) {
                shouldReprocess = true;
              }
            }
          });
        }
      });

      if (shouldReprocess) {
        // Reset processed flags for new elements
        document.querySelectorAll('[data-size-swatch-processed]').forEach(function(el) {
          delete el.dataset.sizeSwatchProcessed;
        });
        processSizeVariants();
        initVariantAccordions();
      }
    });

    // Observe the product info container
    const productInfoContainer = document.querySelector('.xo-product-info-content') || 
                                 document.querySelector('xo-product') ||
                                 document.body;
    
    if (productInfoContainer) {
      observer.observe(productInfoContainer, {
        childList: true,
        subtree: true
      });
    }

    // Also listen for custom events that might indicate variant changes
    document.addEventListener('change', function(e) {
      if (e.target.matches('input[type="radio"][name*="Size"]')) {
        setTimeout(processSizeVariants, 100);
      }
    });
  }

  // Initialize when script loads
  init();

  //
  // Variant instant feedback (price + selected option labels)
  //

  const priceElementMeta = new WeakMap();
  const productContexts = new WeakMap();

  function sanitizeJson(text) {
    return text
      .replace(/,\s*}/g, '}')
      .replace(/,\s*]/g, ']');
  }

  function getProductData(productEl) {
    const script = productEl.querySelector('xo-product-data script');
    if (!script) return null;
    try {
      const json = sanitizeJson(script.textContent || '');
      return JSON.parse(json);
    } catch (err) {
      console.warn('Unable to parse product data JSON', err);
      return null;
    }
  }

  function formatMoneyValue(amount, withCurrency = false) {
    const cents = typeof amount === 'number' ? amount : parseInt(amount || 0, 10);
    if (Number.isNaN(cents)) {
      return '';
    }
    const attrName = withCurrency ? 'xo-money-with-currency-format' : 'xo-money-format';
    const fallbackFormat = withCurrency ? '${{amount_with_currency}}' : '${{amount}}';
    const formatString = document.documentElement.getAttribute(attrName) || fallbackFormat;

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, formatString);
    }

    try {
      const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency,
      });
    } catch (err) {
      return `${(cents / 100).toFixed(2)}`;
    }
  }

  function detectCurrencyPreference(priceEl, variant) {
    const referenceEl =
      priceEl.querySelector('.xo-price__sale .xo-price__item:not(.xo-price__item--del)') ||
      priceEl.querySelector('.xo-price__regular .xo-price__item') ||
      priceEl.querySelector('.xo-price__item');
    if (!referenceEl || !variant) {
      return false;
    }
    const content = referenceEl.textContent.replace(/\s+/g, ' ').trim();
    const withCode = formatMoneyValue(variant.price, true).replace(/\s+/g, ' ').trim();
    const withoutCode = formatMoneyValue(variant.price, false).replace(/\s+/g, ' ').trim();
    if (content === withCode || content.includes(withCode)) {
      return true;
    }
    if (content === withoutCode || content.includes(withoutCode)) {
      return false;
    }
    return false;
  }

  function getPriceMeta(priceEl, variant) {
    if (priceElementMeta.has(priceEl)) {
      return priceElementMeta.get(priceEl);
    }
    const meta = {
      usesCurrencyWithCode: detectCurrencyPreference(priceEl, variant),
    };
    priceElementMeta.set(priceEl, meta);
    return meta;
  }

  function updatePriceElement(priceEl, variant) {
    if (!variant) return;
    const meta = getPriceMeta(priceEl, variant);
    const formattedPrice = formatMoneyValue(variant.price, meta.usesCurrencyWithCode);
    const formattedCompare =
      variant.compare_at_price > variant.price
        ? formatMoneyValue(variant.compare_at_price, meta.usesCurrencyWithCode)
        : '';

    const saleWrapper = priceEl.querySelector('.xo-price__sale');
    const regularWrapper = priceEl.querySelector('.xo-price__regular');

    if (saleWrapper) {
      const salePriceEl = saleWrapper.querySelector('.xo-price__item:not(.xo-price__item--del)');
      const compareEl = saleWrapper.querySelector('.xo-price__item--del');
      if (salePriceEl) {
        salePriceEl.textContent = formattedPrice;
      }
      if (compareEl) {
        compareEl.textContent = formattedCompare || '';
      }
      if (!formattedCompare) {
        saleWrapper.style.display = 'none';
        if (regularWrapper) {
          regularWrapper.style.display = '';
          const regularPriceEl = regularWrapper.querySelector('.xo-price__item');
          if (regularPriceEl) {
            regularPriceEl.textContent = formattedPrice;
          }
        }
      } else {
        saleWrapper.style.display = '';
        if (regularWrapper) {
          regularWrapper.style.display = 'none';
        }
      }
      return;
    }

    if (regularWrapper) {
      const regularPriceEl = regularWrapper.querySelector('.xo-price__item');
      if (regularPriceEl) {
        regularPriceEl.textContent = formattedPrice;
      }
      return;
    }

    const fallback = priceEl.querySelector('.xo-price__item');
    if (fallback) {
      fallback.textContent = formattedPrice;
    }
  }

  function updatePrices(productId, variant) {
    if (!variant) return;
    const selector = `[xo-unique-id="product-price-${productId}"]`;
    document.querySelectorAll(selector).forEach((priceEl) => {
      updatePriceElement(priceEl, variant);
    });
  }

  function updateVariantLabels(selected, productId) {
    if (!selected || !productId) {
      return;
    }
    Object.keys(selected).forEach((optionName) => {
      const value = selected[optionName];
      if (!value) return;
      const escapedName = escapeAttributeValue(optionName);
      const selector = `[xo-unique-id="product-variant-${escapedName}-${productId}"]`;
      document.querySelectorAll(selector).forEach((el) => {
        el.textContent = value;
      });
    });
  }

  function createProductContext(productEl) {
    const productId = productEl.getAttribute('xo-product-id');
    const sectionId = productEl.getAttribute('xo-section-id');
    if (!productId || !sectionId) return null;

    const productData = getProductData(productEl);
    if (!productData || !Array.isArray(productData.variants)) return null;

    const variantMap = new Map();
    productData.variants.forEach((variant) => {
      variantMap.set(String(variant.id), variant);
    });

    return {
      productEl,
      productId,
      stateKey: `${sectionId}/${productId}`,
      variantMap,
      productData,
      optionNames: Array.isArray(productData.options) ? productData.options : [],
      lastVariantId: null,
      lastSelectionKey: '',
    };
  }

  function getProductContext(productEl) {
    if (!productEl) return null;
    let context = productContexts.get(productEl);
    if (!context) {
      context = createProductContext(productEl);
      if (context) {
        productContexts.set(productEl, context);
      }
    }
    return context;
  }

  function normalizeOptionValue(value) {
    return (value || '')
      .toString()
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function collectSelectionFromDom(productEl) {
    if (!productEl) return null;
    const selection = { byName: {}, byPosition: {} };
    const variantBlocks = productEl.querySelectorAll('[data-variant-accordion]');

    variantBlocks.forEach((block) => {
      let value = null;
      const checkedInput = block.querySelector('input[type="radio"][name]:checked');
      if (checkedInput && checkedInput.name) {
        value = checkedInput.getAttribute('xo-label') || checkedInput.value;
      } else {
        const selectEl = block.querySelector('select[name]');
        if (selectEl && selectEl.name) {
          value =
            selectEl.options && selectEl.selectedIndex > -1
              ? selectEl.options[selectEl.selectedIndex].value
              : selectEl.value;
        }
      }

      if (value == null) {
        return;
      }

      const optionName = block.getAttribute('data-option-name');
      if (optionName) {
        selection.byName[optionName] = value;
      }

      const optionPosition = parseInt(block.getAttribute('data-option-position'), 10);
      if (!Number.isNaN(optionPosition)) {
        selection.byPosition[optionPosition] = value;
      }
    });

    if (
      !Object.keys(selection.byName).length &&
      !Object.keys(selection.byPosition).length
    ) {
      return null;
    }

    return selection;
  }

  function findVariantFromSelection(context, selection) {
    if (!context || !selection) return null;
    const optionNames = Array.isArray(context.optionNames) ? context.optionNames : [];
    if (!optionNames.length) return null;

    return (
      context.productData.variants.find((variant) => {
        return optionNames.every((optionName, index) => {
          const position = index + 1;
          const selectedValue =
            (selection.byPosition && selection.byPosition[position]) ||
            (selection.byName && selection.byName[optionName]);
          if (!selectedValue) {
            return false;
          }
          const variantValue = variant.options[index];
          return normalizeOptionValue(variantValue) === normalizeOptionValue(selectedValue);
        });
      }) || null
    );
  }

  function applyDomSelection(context) {
    if (!context) return;
    const selection = collectSelectionFromDom(context.productEl);
    if (!selection) return;

    const selectionKey = JSON.stringify(selection.byName || selection.byPosition || {});
    if (selectionKey !== context.lastSelectionKey) {
      context.lastSelectionKey = selectionKey;
      if (selection.byName && Object.keys(selection.byName).length) {
        updateVariantLabels(selection.byName, context.productId);
      }
    }

    const variant = findVariantFromSelection(context, selection);
    if (variant) {
      const variantId = String(variant.id);
      if (variantId !== context.lastVariantId) {
        context.lastVariantId = variantId;
      }
      updatePrices(context.productId, variant);
    }
  }

  function applyStateSnapshot(context, formState) {
    if (!formState) return;

    if (formState.variantSelected) {
      const selectionKey = JSON.stringify(formState.variantSelected);
      if (selectionKey !== context.lastSelectionKey) {
        context.lastSelectionKey = selectionKey;
        updateVariantLabels(formState.variantSelected, context.productId);
      }
    }

    if (formState.variantId) {
      const variantId = String(formState.variantId);
      if (variantId !== context.lastVariantId) {
        context.lastVariantId = variantId;
        const variant = context.variantMap.get(variantId);
        updatePrices(context.productId, variant);
      }
    }
  }

  function initVariantInstantSync() {
    if (typeof window === 'undefined' || typeof window.cartFormSubscribe !== 'function') {
      return;
    }

    document
      .querySelectorAll('xo-product[xo-product-information][xo-product-id][xo-section-id]')
      .forEach((productEl) => {
        if (productEl.dataset.variantInstantBound === 'true') {
          return;
        }
        const context = getProductContext(productEl);
        if (!context) {
          return;
        }

        const handleChange = (state) => {
          if (!state) return;
          applyStateSnapshot(context, state[context.stateKey]);
        };

        handleChange(
          typeof window.getCartFormState === 'function' ? window.getCartFormState() : null
        );

        window.cartFormSubscribe(handleChange);
        productEl.dataset.variantInstantBound = 'true';
        applyDomSelection(context);
      });
  }

  initVariantInstantSync();
  document.addEventListener('shopify:section:load', initVariantInstantSync);

  document.addEventListener('change', (event) => {
    const target = event.target;
    const isRadioInput = target instanceof HTMLInputElement && target.type === 'radio';
    const isSelectInput = target instanceof HTMLSelectElement;
    if (!isRadioInput && !isSelectInput) {
      return;
    }

    const panel =
      target.closest('[data-variant-accordion-panel]') ||
      target.closest('[data-variant-accordion]');
    if (!panel) {
      return;
    }

    const variantWrapper = panel.closest('[data-variant-accordion]') || panel;
    if (!variantWrapper) {
      return;
    }

    const productEl = variantWrapper.closest('xo-product[xo-product-id][xo-section-id]');
    if (!productEl) {
      return;
    }

    const context = getProductContext(productEl);
    if (!context) {
      return;
    }

    applyDomSelection(context);
  });

})();

